import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import Header from "../../Common/Layout/Header";
import SettingsTabs from "../AllTabs/SettingsTabs";
import { toast } from "react-toastify";
const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "2rem",
    padding: "2rem",
  },
  textContainer: {
    flex: 1,
  },
  carouselContainer: {
    flex: 1,
    maxWidth: "500px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    borderRadius: "8px",
    overflow: "hidden",
  },
  video: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  heading: {
    fontSize: "1.75rem",
    fontWeight: "600",
    marginBottom: "1rem",
  },
  paragraph: {
    fontSize: "1rem",
    color: "#555",
    marginBottom: "1.5rem",
  },
  button: {
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
  },
  caption: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: "5px",
  },
  whatsAppSection: {
    border: "1px solid #dee2e6",
    borderRadius: "8px",
    padding: "1.5rem",
    backgroundColor: "#f8f9fa",
  },
  statusLabel: {
    fontWeight: "500",
    color: "#6c757d",
    marginBottom: "0.5rem",
    display: "block",
  },
  statusValue: {
    fontWeight: "600",
    fontSize: "1.2rem",
    marginRight: "1rem",
    color: "#212529",
  },
  inputGroup: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  inputField: {
    maxWidth: "250px",
    flex: "1 1 auto",
  },
};

const carouselItems = [
  {
    title: "Chat About Travel Packages",
    videoSrc: "/videos/packages-demo.mp4",
  },
  {
    title: "Get Instant Visa Assistance",
    videoSrc: "/videos/visa-demo.mp4",
  },
];

const ChatBotSettings = () => {
  const { user, refreshUserProfile } = useAuth();
  const videoRefs = useRef([]);
  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [whatsAppNumberInput, setWhatsAppNumberInput] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const handleSlideChange = (event) => {
      const newIndex = event.to;
      setActiveIndex(newIndex);

      videoRefs.current.forEach((video) => {
        if (video) video.pause();
      });

      const activeVideo = videoRefs.current[newIndex];
      if (activeVideo) {
        activeVideo.currentTime = 0;
        activeVideo
          .play()
          .catch((error) => console.log("Autoplay was prevented:", error));
      }
    };

    const carouselElement = carouselRef.current;
    if (carouselElement) {
      carouselElement.addEventListener("slide.bs.carousel", handleSlideChange);

      const firstVideo = videoRefs.current[0];
      if (firstVideo) {
        firstVideo
          .play()
          .catch((error) => console.log("Autoplay was prevented:", error));
      }
    }

    return () => {
      if (carouselElement) {
        carouselElement.removeEventListener(
          "slide.bs.carousel",
          handleSlideChange,
        );
      }
    };
  }, []);
  useEffect(() => {

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "1312609543790879",
        cookie: true,
        xfbml: true,
        version: "v18.0"
      });
    };

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    document.body.appendChild(script);

  }, []);

  const connectWhatsApp = () => {

    window.FB.login((response) => {

      if (!response.authResponse) return;

      const code = response.authResponse.code;

      fetch("http://localhost:5126/api/whatsapp/onboard", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          code: code,
          companyId: user.cid
        })
      });

    }, {
      config_id: "950617934056166",
      response_type: "code",
      override_default_response_type: true,
      extras: {
        setup: {
          business: {
            name: user.brandName,
            website: user.primaryDomain
          },
          phone: {
            number: user.whatsappnumber,
            display_name: user.brandName
          }
        }
      }
    });

  };

  const startSignup = async () => {
    try {
      const redirectUri = `${window.location.origin}/whatsapp-callback`;
      const companyId = user?.cid;
      const res = await apiService.post(config.CONNECTWHATSSDK, {
        companyId,
        redirectUri,
      });
      const response = res.data || res;
      const { url, state } = response;
      if (!url) {
        console.error("Missing URL in backend response", response);
        alert("Failed to start WhatsApp signup flow");
        return;
      }
      const popup = window.open(url, "waSignup", "width=900,height=700");
      if (!popup) alert("Please enable popups for this site.");
    } catch (err) {
      console.error(err);
      alert("Error starting WhatsApp signup");
    }
  };

  const handleSaveWhatsAppNumber = async () => {
    if (!whatsAppNumberInput) {
      alert("Please enter a WhatsApp number.");
      return;
    }
    setIsSaving(true);
    const formData = new FormData();
    formData.append("companyId", user?.cid);
    formData.append("whatsAppNumber", whatsAppNumberInput);
    try {
      await apiService.update(config.UPDATEWHATSAPPNUMBER, formData);
      await refreshUserProfile();
      setWhatsAppNumberInput("");
    } catch (err) {
      console.error("Failed to update WhatsApp number:", err);
      toast.error("An error occurred while saving. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <SettingsTabs pageName="CHATBOT" />
                </div>
                <div style={styles.container}>
                  <div style={styles.textContainer}>
                    <h2 style={styles.heading}>
                      Engage Travelers 24/7 with an AI Chatbot
                    </h2>
                    <p style={styles.paragraph}>
                      Showcase travel packages, assist with visa queries, and
                      answer questions instantly. Automate customer
                      conversations on WhatsApp to boost conversions
                      effortlessly.
                    </p>
                    <div style={styles.whatsAppSection}>
                      {user?.whatsAppNumber ? (
                        // STATE 1: Number exists, display status
                        <div>
                          <div className="mb-3">
                            <label style={styles.statusLabel}>
                              Connected WhatsApp Number
                            </label>
                            <span style={styles.statusValue}>
                              {user.whatsAppNumber}
                            </span>
                          </div>
                          <div>
                            <label style={styles.statusLabel}>
                              Chatbot Connection Status
                            </label>
                            {user.isChatBot ? (
                              <span className="badge bg-success fs-6">
                                Connected
                              </span>
                            ) : (
                              <span className="badge bg-danger fs-6">
                                Not Connected
                              </span>
                            )}
                          </div>
                        </div>
                      ) : (
                        // STATE 2: Number does not exist, show input form
                        <div>
                          <label
                            style={styles.statusLabel}
                            htmlFor="whatsAppNumber"
                          >
                            Enter Your WhatsApp Business Number
                          </label>
                          <div style={styles.inputGroup}>
                            <input
                              type="text"
                              id="whatsAppNumber"
                              className="form-control"
                              style={styles.inputField} // Apply the new style here
                              placeholder="+919123456789"
                              value={whatsAppNumberInput}
                              onChange={(e) =>
                                setWhatsAppNumberInput(e.target.value)
                              }
                              disabled={isSaving}
                            />
                            <button
                              className="btn btn-success"
                              onClick={handleSaveWhatsAppNumber}
                              disabled={isSaving}
                            >
                              {isSaving ? "Saving..." : "Save"}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <button
                      onClick={connectWhatsApp}
                      className="btn btn-primary"
                      style={styles.button}
                    >
                      Connect WhatsApp
                    </button>
                  </div>

                  {/* START: Bootstrap Carousel */}
                  <div style={styles.carouselContainer}>
                    <div
                      id="chatbotDemoCarousel"
                      ref={carouselRef}
                      className="carousel slide"
                      data-bs-ride="carousel"
                    >
                      <div className="carousel-indicators">
                        {carouselItems.map((_, index) => (
                          <button
                            key={index}
                            type="button"
                            data-bs-target="#chatbotDemoCarousel"
                            data-bs-slide-to={index}
                            className={index === activeIndex ? "active" : ""}
                            aria-current={
                              index === activeIndex ? "true" : "false"
                            }
                            aria-label={`Slide ${index + 1}`}
                          ></button>
                        ))}
                      </div>
                      <div className="carousel-inner">
                        {carouselItems.map((item, index) => (
                          <div
                            key={index}
                            className={`carousel-item ${index === activeIndex ? "active" : ""}`}
                            style={{ textAlign: "center" }} // keeps title centered
                          >
                            <video
                              ref={(el) => (videoRefs.current[index] = el)}
                              style={styles.video}
                              src={item.videoSrc}
                              loop
                              muted
                              playsInline
                            />

                            {/* MOVE CAPTION OUTSIDE THE VIDEO */}
                            <div
                              className="carousel-caption"
                              style={{ position: "static", ...styles.caption }}
                            >
                              <h5>{item.title}</h5>
                            </div>
                          </div>
                        ))}
                      </div>

                      <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#chatbotDemoCarousel"
                        data-bs-slide="prev"
                      >
                        <span
                          className="carousel-control-prev-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#chatbotDemoCarousel"
                        data-bs-slide="next"
                      >
                        <span
                          className="carousel-control-next-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBotSettings;
